import { useEffect, useState } from 'react';
import { MOBILE_MAX } from 'styles/media';

const QUERY = `(max-width: ${MOBILE_MAX}px)`;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handleChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handleChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
